import React, { Component } from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import Moment from "react-moment"
import moment from "moment"
import isEmpty from "lodash/isEmpty"
import DayPicker from "react-day-picker"
import "react-day-picker/lib/style.css"
import { provideContext } from "../../../../context/context.jsx"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEdit } from "@fortawesome/free-solid-svg-icons"
import Message from "../../presentation/message/message.jsx"
import * as apiOrdersSelector from "../../../../redux-api/apiOrders/apiOrdersSelectors.js"
import { Trans } from "react-i18next"

import "./overviewPanelRetail.scss"
import orderStatuses from "../../../../enums/orderStatuses"
import ReactTooltip from "react-tooltip"
import returnStatuses from "../../../../enums/returnStatuses"

import ReactGA from "react-ga4"
import showMoreInfoIcon from "../../../../assets/icons/show-more.svg"
import linkEnums from "../../../../enums/linksEnum"

class OverviewPanelRetail extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false,
      focused: false,
      shippingDate: moment(props.shippingDate),
      canBeEdited: true,
      showOptions: false,
    }
    this.announcerRef = React.createRef()
    this.dayPickerRef = React.createRef()
    this.previouslyFocusedElement = null
  }

  announce = (message) => {
    if (this.announcerRef.current) {
      this.announcerRef.current.textContent = ""

      setTimeout(() => {
        if (this.announcerRef.current) {
          this.announcerRef.current.textContent = message
        }
      }, 50)
    }
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside)
    document.addEventListener("keydown", this.handleKeyDown)
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside)
    document.removeEventListener("keydown", this.handleKeyDown)
  }

  handleKeyDown = (event) => {
    if (this.state.showOptions && event.key === "Escape") {
      this.setState({
        showOptions: false,
        announcement: "Order options menu closed",
      })
    }

    if (this.state.isOpen && event.key === "Escape") {
      this.closeCalendar()
    }
  }

  handleCalendarKeyDown = (e) => {
    const { shippingDate } = this.state
    const newDate = moment(shippingDate)
    let dateChanged = false

    const isMonthNavButton =
      (e.target.classList && e.target.classList.contains("DayPicker-NavButton")) ||
      (e.target.closest && e.target.closest(".DayPicker-NavButton")) ||
      (e.target.classList && e.target.classList.contains("DayPicker-Caption")) ||
      (e.target.closest && e.target.closest(".DayPicker-Caption"))


    if ((e.key === "Enter" || e.key === " ") && isMonthNavButton) {
      return
    }

    switch (e.key) {
      case "ArrowRight":
        newDate.add(1, "day")
        if (newDate.day() === 0) newDate.add(1, "day")
        if (newDate.day() === 6) newDate.add(2, "day")
        dateChanged = true
        e.preventDefault()
        break
      case "ArrowLeft":
        newDate.subtract(1, "day")
        if (newDate.day() === 0) newDate.subtract(2, "day")
        if (newDate.day() === 6) newDate.subtract(1, "day")
        dateChanged = true
        e.preventDefault()
        break
      case "ArrowUp":
        newDate.subtract(7, "day")
        dateChanged = true
        e.preventDefault()
        break
      case "ArrowDown":
        newDate.add(7, "day")
        dateChanged = true
        e.preventDefault()
        break
      case "Enter":
      case " ": // Space key
        this.handleChangeShippingDate(newDate)
        e.preventDefault()
        return
      case "Escape":
        this.closeCalendar()
        e.preventDefault()
        return
      default:
        return
    }

    const today = moment()
    const fourMonthsFromNow = moment().add(4, "months")

    if (
      newDate.isBefore(today, "day") ||
      newDate.isAfter(fourMonthsFromNow, "day") ||
      newDate.day() === 0 ||
      newDate.day() === 6
    ) {
      this.announce(`${newDate.format("MMMM D")} is not available for selection. Please choose another date.`)

      return
    }

    if (dateChanged) {
      this.setState({
        shippingDate: newDate,
      })


    }
  }

  focusCalendar = () => {
    if (this.dayPickerRef && this.dayPickerRef.current) {
      const container = this.dayPickerRef.current.dayPicker;
      if (container) {
        const selectedDayElement = container.querySelector('.DayPicker-Day.DayPicker-Day--selected');

        if (selectedDayElement) {
          selectedDayElement.focus();
          this.announce(`Calendar opened. Use arrow keys to navigate dates.`);
        }
      }
    }
  }

  handleChangeShippingDate = (newDate) => {
    const { order } = this.props
    const formattedDate = moment(newDate).format("MMMM D, YYYY")
    const dayOfWeek = moment(newDate).format("dddd")

    this.setState({
      isOpen: false,
      focused: false,
      shippingDate: moment(newDate),
    })

    this.announce(`Shipping date selected: ${dayOfWeek}, ${formattedDate}. Your order will ship within 4 business days of this date.`)
    this.props.apiUpdateShippingDate({
      orderId: order._id,
      shippingDate: moment(newDate).format("YYYY-MM-DD"),
    })

    ReactGA.event({
      category: "Button Clicked",
      action: "retail_ship_date_changed",
      label: "Retail Shipping date has been changed",
    })

    if (this.previouslyFocusedElement) {
      this.previouslyFocusedElement.focus()
    }
  }

  handleCancelOrderClick = () => {
    const { order } = this.props
    this.props.showCancelOrderModal(order._id)
  }

  handleEditAddressClick = () => {
    const { order } = this.props
    this.props.showEditAddressModal(order)
  }

  openCalendar = (event) => {
    this.previouslyFocusedElement = document.activeElement
    this.setState({
      isOpen: true,
      announcement: "Calendar opened. Use arrow keys to navigate and Enter to select a date.",
    })


  }

  closeCalendar = () => {
    this.setState(
      {
        focused: false,
      },
      () => {
        if (this.previouslyFocusedElement) {
          this.previouslyFocusedElement.focus()
        }
      },
    )
    this.announce("Calendar closed. No date was selected.")
  }

  renderError = (errors) => {
    return (
      <div className="order-status-overview-error">
        <Message type="error">{errors.error.message}</Message>
      </div>
    )
  }

  filterDate = (date) => {
    const today = moment()
    const fourMonthsFromNow = moment().add(4, "months")

    const momentDate = moment(date)

    if (momentDate.isBefore(today, "day")) {
      return false
    }

    if (momentDate.day() === 0 || momentDate.day() === 6) {
      return false
    }

    if (momentDate.isAfter(fourMonthsFromNow, "day")) {
      return false
    }

    return true
  }

  toggleOptions = (e) => {
    e.stopPropagation()
    const newState = !this.state.showOptions

    this.setState({
      showOptions: newState,
      announcement: newState ? "Order options menu opened" : "Order options menu closed",
    })

  }

  handleClickOutside = (event) => {
    if (this.dropdownRef && !this.dropdownRef.contains(event.target)) {
      if (this.state.showOptions) {
        this.setState({
          showOptions: false,
          announcement: "Order options menu closed",
        })

      }
    }
  }

  setDropdownRef = (node) => {
    this.dropdownRef = node
  }

  skipReturnCheck = (order) => {
    const SPECIAL_RESEARCH_TAG = "special research order"

    if (order.type === "CORPORATE_RENTAL_10") {
      return true
    }

    const tags = order.tags
      .split(",")
      .map((tag) => tag.trim())
      .filter(Boolean)

    return !!tags.includes(SPECIAL_RESEARCH_TAG)
  }

  isInReturnPeriod = (order) => {
    if (this.skipReturnCheck(order)) {
      return true
    }

    const thirtyDaysAgo = moment().subtract(30, "days")
    const deliveredStatus = order.statusHistory.find((status) => status.status === orderStatuses.DELIVERED)
    return deliveredStatus && moment(deliveredStatus.date).isSameOrAfter(thirtyDaysAgo)
  }

  shouldShowReturn = (order) => {
    if (this.skipReturnCheck(order)) {
      return true
    }

    return (
      order.name.startsWith("#SH") &&
      !this.props.isReturn &&
      order.status === orderStatuses.DELIVERED &&
      this.isInReturnPeriod(order)
    )
  }

  render() {
    const {
      t,
      context,
      userData,
      title,
      iconName,
      showButton,
      showShippingDate,
      itemData,
      lineItems,
      order,
      successShippingDateUpdate,
      errorShippingDateUpdate,
      currentReturn,
    } = this.props

    let firstName, lastName, address1, address2, city, zip, province, country
    if (currentReturn && currentReturn.shippingAddressFrom) {
      ;({ firstName, lastName, address1, address2, city, zip, province, country } = currentReturn.shippingAddressFrom)
    } else {
      ;({
        first_name: firstName,
        last_name: lastName,
        address1,
        address2,
        city,
        zip,
        province,
        country,
      } = order.shipping_address)
    }

    const fullName = `${firstName} ${lastName}`
    const shippingAddress = `${address1}, ${address2 ? address2 + ", " : ""}${city} ${zip}, ${
      province ? province + "," : ""
    } ${country}`
    const showSchedulePickup =
      (currentReturn && currentReturn.status === returnStatuses) ||
      (currentReturn && !currentReturn.cancelledAtWarehouse)

    const isDigitalProductOrderOnly = order.line_items.every((li) => !li.requires_shipping)
    if (isDigitalProductOrderOnly) {
      order.status = orderStatuses.PLACED
    }

    // Custom navigation component that prevents calendar from closing when Enter is pressed
    const CustomNavbar = ({ onPreviousClick, onNextClick, className, showNextButton, showPreviousButton }) => (
      <div className={className} role="navigation">
        {showPreviousButton && (
          <button
            className="DayPicker-NavButton DayPicker-NavButton--prev"
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              onPreviousClick()
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault()
                e.stopPropagation()
                onPreviousClick()
              }
            }}
            aria-label="Previous month"
            type="button"
          >
          </button>
        )}
        {showNextButton && (
          <button
            className="DayPicker-NavButton DayPicker-NavButton--next"
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              onNextClick()
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault()
                e.stopPropagation()
                onNextClick()
              }
            }}
            aria-label="Next month"
            type="button"
          >
          </button>
        )}
      </div>
    )

    return (
      <div className="OverviewPanelRetail">
        <div
          ref={this.announcerRef}
          className="sr-only"
          aria-live="polite"
          aria-atomic="true"
        >
        </div>

        <div className="edit-profile-overview">
          <div className="item">
            <h4 id="customer-name-label">{t('overview_panel_name', 'Name')}</h4>
            <p aria-labelledby="customer-name-label">{fullName}</p>
          </div>
          <div className="item">
            <h4 id="customer-email-label">{t('global_email')}</h4>
            <p className="email" data-tip={userData.email} aria-labelledby="customer-email-label">
              {userData.email}
            </p>
            <ReactTooltip place="top" type="dark" effect="float" />
          </div>
          <div className="item">
            <h4 id="shipping-address-label">{t('global_shipping_address', 'Shipping address')}</h4>
            <p aria-labelledby="shipping-address-label">{shippingAddress}</p>
          </div>
          {order.status === 'PLACED' && (
            <button
              tabIndex={0}
              className="edit-icon"
              onClick={this.handleEditAddressClick}
              aria-label="Edit shipping address"
            >
              <FontAwesomeIcon icon={faEdit} size={'lg'} />
            </button>
          )}
          {showSchedulePickup && (
            <a
              className="schedule-link"
              href={linkEnums.SCHEDULE_PICKUPS}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Schedule pickup - opens in a new tab"
            >
              Schedule Pickup
            </a>
          )}
        </div>

        <div className="order-status-overview-retail">
          <div className="icon-wrap">
            <div className="icon-center">
              <div className="icon active">
                <div className="circle">
                  <img src={iconName || '/placeholder.svg'} className="active" alt={`${title} status icon`} />
                </div>
                <div className="label">
                  <h4>{title}</h4>
                </div>
              </div>
            </div>
          </div>
          <div className="details-wrap">
            <div className="details-center">
              {this.shouldShowReturn(order) && (
                <div className="button-container" ref={this.setDropdownRef}>
                  <div
                    className="button"
                    id="menu-button"
                    onClick={(e) => this.toggleOptions(e)}
                    role="button"
                    tabIndex={0}
                    aria-haspopup="menu"
                    aria-expanded={this.state.showOptions}
                    aria-label="Order options menu"
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        this.toggleOptions(e);
                      }
                    }}
                  >
                    <img src={showMoreInfoIcon || '/placeholder.svg'} alt="" aria-hidden="true" />
                    <span className="sr-only">Show order options</span>
                  </div>
                  {this.state.showOptions && (
                    <div className="dropdown" role="menu" aria-labelledby="menu-button" tabIndex="-1">
                      <button
                        type="button"
                        className="form-button"
                        role="menuitem"
                        tabIndex="0"
                        id="menu-item-1"
                        onClick={() => this.props.showInitReturnModal(this.props.order, this.props.returns)}
                      >
                        Return Order
                      </button>
                    </div>
                  )}
                </div>
              )}
              <div className="details">
                {itemData &&
                  itemData.map((item, index) => {
                    return (
                      <div key={index} className="details-item">
                        <h4 id={`item-title-${index}`}>{item.title}</h4>
                        <div className="item-detail" aria-labelledby={`item-title-${index}`}>
                          {item.value}
                        </div>
                      </div>
                    );
                  })}

                {showShippingDate && order.status === 'PLACED' && (
                  <div className="details-item">
                    <h4 id="shipping-date-label">{t('overview_panel_shipping_date_title', 'Shipping date')}</h4>

                    {successShippingDateUpdate && (
                      <p className="success-message" role="status" aria-live="polite">
                        {t(
                          'overview_pannel_shipping_date_changed_success',
                          'You have successfully changed the shipping date.'
                        )}
                      </p>
                    )}
                    {!isEmpty(errorShippingDateUpdate) && (
                      <p className="error-message" role="alert">
                        {t('overview_panel_shipping_date_not_changed', 'You did not change shipping date')}
                      </p>
                    )}

                    {!this.state.focused ? (
                      <div className="shipping-date-display">
                        <span aria-labelledby="shipping-date-label">
                          <Moment format={context.apiConfig.date.format} date={this.state.shippingDate} />
                        </span>
                        <button
                          className="edit-icon"
                          onClick={() => {
                            this.setState({ focused: true }, () => {
                              setTimeout(this.focusCalendar, 0);
                            });
                          }}
                          aria-label={`Edit shipping date. Current date is ${moment(this.state.shippingDate).format('dddd, MMMM D, YYYY')}`}
                          aria-expanded={this.state.focused}
                          aria-controls="shipping-date-calendar"
                        >
                          <FontAwesomeIcon icon={faEdit} />
                        </button>
                      </div>
                    ) : (
                      <div className="day-picker-container" id="shipping-date-calendar">
                        <div className="sr-only" id="calendar-instructions">
                          Use arrow keys to navigate days: left and right arrows move by day, up and down arrows move by
                          week. Press Enter or Space to select a date. Press Escape to close the calendar without making
                          a selection. Only weekdays within the next four months are available for selection. Weekends
                          and past dates are disabled. The currently focused date will be announced as you navigate.
                        </div>

                        <DayPicker
                          ref={this.dayPickerRef}
                          selectedDays={this.state.shippingDate.toDate()}
                          month={this.state.shippingDate.toDate()}
                          onDayClick={(day, { disabled }) => {
                            if (!disabled) {
                              this.handleChangeShippingDate(moment(day))
                            } else {
                              this.announce(`${moment(day).format("MMMM D")} is not available for selection.`)
                            }
                          }}
                          disabledDays={[
                            { daysOfWeek: [0, 6] },
                            { before: new Date() },
                            { after: moment().add(4, 'months').toDate() }
                          ]}
                          fromMonth={new Date()}
                          toMonth={moment().add(4, 'months').toDate()}
                          firstDayOfWeek={1}
                          aria-label="Shipping date calendar"
                          aria-describedby="calendar-instructions"
                          onKeyDown={this.handleCalendarKeyDown}
                          containerProps={{
                            tabIndex: 0,
                            className: 'calendar-container-accessible',
                            role: 'application',
                            'aria-roledescription': 'calendar'
                          }}
                          navbarElement={CustomNavbar}
                          renderDay={(day) => {
                            const date = day.getDate();
                            const isSelected = moment(day).isSame(this.state.shippingDate, 'day');
                            const isToday = moment(day).isSame(moment(), 'day');
                            const isDisabled = !this.filterDate(day);

                            return (
                              <div
                                role="gridcell"
                                tabIndex={-1}
                                aria-selected={isSelected}
                                aria-disabled={isDisabled}
                                aria-current={isToday ? 'date' : undefined}
                              >
                                {date}
                              </div>
                            );
                          }}
                        />
                        <div className="day-picker-footer">
                          <button
                            className="close-calendar-button"
                            onClick={() => this.closeCalendar()}
                            aria-label="Close calendar without selecting a date"
                          >
                            Close
                          </button>
                        </div>
                      </div>
                    )}

                    <p className="shipping-date-disclaimer" id="date-instructions">
                      <Trans i18nKey="overview_panel_shipping_date_allow_two_to_five">
                        Ships within 4 business days of the date you pick. Allow an <em>additional</em> 2-5 business
                        days for SNOO to arrive.
                      </Trans>
                    </p>
                  </div>
                )}
                {order.status === orderStatuses.PLACED && !isDigitalProductOrderOnly && (
                  <div className="details-item">
                    <button
                      className="danger-text cancel-order-action"
                      onClick={this.handleCancelOrderClick}
                      aria-label="Cancel order"
                    >
                      {t('button_text_cancel_order', 'Cancel order')}
                    </button>
                  </div>
                )}
                {order.status === orderStatuses.DELIVERED && !this.isInReturnPeriod(order) && !this.props.isReturn && (
                  <div className="details-item">
                    <p className="danger-text cancel-order-action" role="status">
                      {t('return_period_is_over', 'The 30-day return period has ended.')}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  successShippingDateUpdate: apiOrdersSelector.getUpdateOrderShippingDateSuccess(state),
  errorShippingDateUpdate: apiOrdersSelector.getUpdateOrderShippingDateErrors(state),
})

OverviewPanelRetail.propTypes = {
  t: PropTypes.func.isRequired,
  userData: PropTypes.object.isRequired,
  shippingDate: PropTypes.string,
  showCancelOrderModal: PropTypes.func,
  showEditAddressModal: PropTypes.func,
  showInitReturnModal: PropTypes.func,
  isReturn: PropTypes.bool,
  currentReturn: PropTypes.object,
  returns: PropTypes.array,
}

export default provideContext(connect(mapStateToProps)(OverviewPanelRetail))

